module.exports = __webpack_public_path__ + "static/media/logoCompany.a82babee.svg";